
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppSelect, AppCard, AppButton } from '@/components';
import { useCollectionTranslation } from '@/modules/collection/model/translate';

export default defineComponent({
    name: 'CollectionTranslate',
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, actions, localeSupportedOptions } = useCollectionTranslation();

        return { v$, model, fetch, actions, localeSupportedOptions };
    }
});
